import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import servicePng from '@/shared/assets/png/service.png';
import BookSvg from '@/shared/assets/svg/book.svg';
import DownloadSvg from '@/shared/assets/svg/cloud-download-outlined.svg';
import BulbSvg from '@/shared/assets/svg/bulb.svg';
import { Avatar, Dropdown, Menu, Modal } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
//@ts-ignore
import { QRCodeSVG } from 'qrcode.react';
import { apiConfig, request } from '@/shared/io';
import { getApiUrl, getSystemNameMap } from '@/shared/utils';
import { otherSysPathNameMap } from '@/shared/system';
import { useSharedGlobalState } from '@/shared/hooks';
import { getSystemName } from '@/shared/utils/global';
let openChildWinId = undefined;
const toPath = (type, data) => {
    // 先关闭子窗口
    openChildWinId?.close?.();
    switch (type) {
        case 'home':
            openChildWinId = window.open('/home', '_blank');
            break;
        case 'agreement':
            if (data?.path) {
                openChildWinId = window.open(`/${data?.path}`, '_blank');
            }
            else {
                openChildWinId = window.open(`/portal/${type}/list`, '_blank');
            }
            break;
        case 'help':
            openChildWinId = window.open(otherSysPathNameMap.SupportIndex, '_blank');
            break;
    }
};
const HeaderService = ({ textClass = '' }) => {
    const SYSTRM_NAME_MAP = getSystemNameMap();
    const { authLoginType: REACT_APP_SYS } = useSharedGlobalState();
    const { enName } = getSystemName(REACT_APP_SYS);
    const qrcodePath = useMemo(() => {
        return window.location.origin + '/public/public.html?sys=' + enName;
    }, [enName]); // 下载地址
    const [protocolInfo, setProtocolInfo] = useState({
        path: '',
    });
    const [qRvisible, setQRvisible] = useState(false);
    const menu = (_jsxs(Menu, { children: [_jsx(Menu.Item, { children: _jsxs("p", { style: {
                        cursor: 'pointer', marginBottom: 0, display: 'flex',
                        alignItems: 'center', color: 'var( --lj-primary-color )'
                    }, onClick: () => {
                        toPath('help');
                    }, children: [_jsx(BulbSvg, { style: {
                                width: '20px',
                                height: '20px',
                                marginRight: '4px',
                            } }), _jsx("span", { style: {
                                color: '#000'
                            }, children: "\u5E2E\u52A9\u4E2D\u5FC3" })] }) }), REACT_APP_SYS != 'GOV' && (_jsxs(React.Fragment, { children: [_jsx(Menu.Item, { children: _jsxs("p", { style: {
                                cursor: 'pointer',
                                marginBottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'var( --lj-primary-color )'
                            }, children: [_jsx(BookSvg, { style: {
                                        width: '20px',
                                        height: '20px',
                                        marginRight: '4px',
                                    } }), _jsx("span", { style: {
                                        color: '#000'
                                    }, onClick: () => toPath('agreement', protocolInfo), children: "\u670D\u52A1\u534F\u8BAE" })] }) }), _jsx(Menu.Item, { children: _jsxs("p", { style: {
                                cursor: 'pointer',
                                marginBottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'var( --lj-primary-color )'
                            }, children: [_jsx(DownloadSvg, { style: {
                                        width: '20px',
                                        height: '20px',
                                        marginRight: '4px',
                                    } }), enName ? _jsxs("span", { style: {
                                        color: '#000'
                                    }, onClick: () => setQRvisible(true), children: ["\u4E0B\u8F7D", SYSTRM_NAME_MAP[enName] || SYSTRM_NAME_MAP.KXGC, "APP"] }) : null] }) })] }))] }));
    useEffect(() => {
        if (sessionStorage.getItem('ACCESS_TOKEN')) {
            request(`${apiConfig.apiCms}/v1/cms/content/topProtocol`).then((res) => {
                if (res.code == 200) {
                    setProtocolInfo(res.data);
                }
            });
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Dropdown
            // @ts-ignore
            , { 
                // @ts-ignore
                overlay: menu, children: _jsxs("div", { style: { display: 'inline-block', cursor: 'pointer' }, children: [_jsx(Avatar, { size: 16, className: `grid-icon-mobile`, src: servicePng, alt: "avatar" }), _jsx("span", { className: `grid-header-mobile ${textClass || ''}`, style: { marginLeft: '6px', color: 'rgba(255, 255, 255, 0.9)' }, children: "\u670D\u52A1\u4E2D\u5FC3" })] }) }), _jsx(Modal, { open: qRvisible, onCancel: () => setQRvisible(false), footer: null, centered: true, width: 320, children: _jsx("div", { className: styles.qrBox, children: _jsxs("div", { className: styles.ewm, children: [_jsx("div", { className: styles.ewmout, children: _jsx("div", { className: styles.ewmD2, children: _jsx(QRCodeSVG, { value: qrcodePath, size: 200, fgColor: "#000000" //二维码的颜色
                                        , imageSettings: {
                                            src: `${getApiUrl()}/public/logo/wxLogo_${(enName + '').toLocaleLowerCase()}.png`,
                                            width: 32,
                                            height: 32,
                                            excavate: false,
                                        } }) }) }), _jsxs("div", { className: styles.textRemark, children: ["\u4E0B\u8F7D", SYSTRM_NAME_MAP[enName || 'KXGC'], "APP"] })] }) }) })] }));
};
export default HeaderService;
